// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Main container */
.wrap {
  display: flex;
  gap: 20px;
  width: 100%;
}
@media (max-width: 992px) {
  .wrap {
    flex-direction: column;
    gap: 15px;
  }
}

/* Section containers */
.date-section, .time-section {
  flex: 1;
  min-width: 0;
}

.section-heading {
  color: #B0B0B0;
  line-height: 17px;
  margin: 5px 0 10px 0;
  font-size: 14px;
  font-family: OpenSans, sans-serif;
  text-align: center;
}

/* Slot container */
.slot-container {
  width: 100%;
}

.slot-col {
  min-height: 250px;
  overflow-y: auto;
  padding: 0;
  /* Improved scrollbar for accessibility */
  scrollbar-width: thin;
  scrollbar-color: var(--ion-color-primary) transparent;
  /* Focus styles for listbox */
}
.slot-col::-webkit-scrollbar {
  width: 6px;
}
.slot-col::-webkit-scrollbar-track {
  background: transparent;
}
.slot-col::-webkit-scrollbar-thumb {
  background-color: var(--ion-color-primary);
  border-radius: 3px;
}
.slot-col:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}

/* Slot buttons */
.slot-square {
  background: white;
  text-align: center;
  padding: var(--ion-margin);
  transition: all 0.2s ease;
  text-transform: uppercase;
  margin-bottom: 4px;
  cursor: pointer;
  border-radius: 16px;
  border: 1.5px solid var(--ion-color-primary);
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Selected state */
  /* Disabled state */
  /* Smaller text variant */
  /* More button styling */
}
.slot-square:focus {
  outline: 2px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.slot-square:focus-visible {
  outline: 2px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
}
.slot-square:hover:not(:disabled) {
  background-color: rgba(113, 167, 97, 0.1);
  border-color: var(--ion-color-primary-shade);
}
.slot-square:active:not(:disabled) {
  background-color: rgba(113, 167, 97, 0.2);
  transform: translateY(1px);
}
.slot-square.selected {
  color: white;
  background: var(--ion-color-primary);
  font-weight: bold;
}
.slot-square.selected:hover {
  background-color: var(--ion-color-primary-shade);
}
.slot-square.selected:focus {
  outline-color: var(--ion-color-primary-tint);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
}
.slot-square:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5;
  color: #999999;
  border-color: #cccccc;
}
.slot-square:disabled:hover {
  background-color: #f5f5f5;
  border-color: #cccccc;
}
.slot-square.smaller {
  font-size: 11px;
  padding: 16px 8px;
  text-transform: lowercase;
  min-height: 40px;
}
.slot-square.more-button {
  background-color: rgba(113, 167, 97, 0.1);
  border-style: dashed;
  font-weight: normal;
}
.slot-square.more-button:hover {
  background-color: rgba(113, 167, 97, 0.2);
}
.slot-square.more-button:focus {
  background-color: rgba(113, 167, 97, 0.15);
}

/* Specific styling for date and time slots */
.date-slot {
  /* Additional styling for date slots if needed */
}

.time-slot {
  /* Additional styling for time slots if needed */
}

/* Legacy classes for backward compatibility */
.header-color {
  color: #B0B0B0;
  line-height: 17px;
  margin: 5px;
  font-size: 14px;
  font-family: OpenSans, sans-serif;
  text-align: center;
}

.no-padding {
  padding: 0px !important;
}

/* High contrast mode enhancements */
.bsg-high-contrast .slot-square {
  border: 2px solid black;
  background: white;
  color: black;
}
.bsg-high-contrast .slot-square:focus {
  outline: 3px solid #0078d7;
  box-shadow: none;
}
.bsg-high-contrast .slot-square:hover:not(:disabled) {
  background-color: #e6f3ff;
  border-color: #0078d7;
}
.bsg-high-contrast .slot-square.selected {
  background: black;
  color: white;
  border: 2px solid white;
}
.bsg-high-contrast .slot-square.selected:focus {
  outline: 3px solid #0078d7;
  outline-offset: 2px;
}
.bsg-high-contrast .slot-square:disabled {
  background-color: #cccccc;
  color: #666666;
  border: 1px dashed black;
}
.bsg-high-contrast .slot-square.more-button {
  background: white;
  border: 2px dashed black;
  color: black;
}
.bsg-high-contrast .slot-square.more-button:hover {
  background-color: #e6f3ff;
}
.bsg-high-contrast .slot-col:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .slot-col::-webkit-scrollbar-thumb {
  background-color: black;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .wrap {
    flex-direction: column;
  }
  .slot-square {
    font-size: 12px;
    padding: 12px 8px;
    min-height: 40px;
  }
  .slot-square.smaller {
    font-size: 10px;
    padding: 12px 6px;
    min-height: 36px;
  }
  .slot-col {
    max-height: 200px;
  }
}
/* Animation for smooth interactions */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.slot-square {
  animation: fadeIn 0.2s ease-in-out;
}

/* Ensure proper spacing in grid layout */
.slot-col > .slot-square:last-child {
  margin-bottom: 0;
}

/* Loading state for slots */
.slot-square.loading {
  opacity: 0.6;
  cursor: wait;
}
.slot-square.loading::after {
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid currentColor;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
  margin-left: 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* Focus management for better keyboard navigation */
.slot-col[role=listbox] {
  /* Allow listbox to receive focus for keyboard navigation */
  /* Highlight focused option within listbox */
}
.slot-col[role=listbox]:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.slot-col[role=listbox] .slot-square[aria-selected=true] {
  position: relative;
}
.slot-col[role=listbox] .slot-square[aria-selected=true]::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border: 2px solid var(--ion-color-primary);
  border-radius: 18px;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-date-formcontrol/select-date-formcontrol.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,4BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA,mBAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,WAAA;AADF;ACXE;EDSF;IAMI,sBAAA;IACA,SAAA;EAAF;AACF;;AAGA,uBAAA;AACA;EACE,OAAA;EACA,YAAA;AAAF;;AAGA;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;AAAF;;AAGA,mBAAA;AACA;EACE,WAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;EAEA,yCAAA;EACA,qBAAA;EACA,qDAAA;EAeA,6BAAA;AAfF;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,uBAAA;AADJ;AAIE;EACE,0CAAA;EACA,kBAAA;AAFJ;AAME;EACE,2CAAA;EACA,mBAAA;AAJJ;;AAQA,iBAAA;AACA;EACE,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,iCAAA;EACA,oCAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAMA,iBAAA;EAMA,mBAAA;EAgBA,mBAAA;EAcA,yBAAA;EAQA,wBAAA;AA9DF;AAAE;EACE,iDAAA;EACA,mBAAA;EACA,8CAAA;AAEJ;AAEE;EACE,iDAAA;EACA,mBAAA;AAAJ;AAIE;EACE,yCAAA;EACA,4CAAA;AAFJ;AAME;EACE,yCAAA;EACA,0BAAA;AAJJ;AAQE;EACE,YAAA;EACA,oCAAA;EACA,iBAAA;AANJ;AAQI;EACE,gDAAA;AANN;AASI;EACE,4CAAA;EACA,8CAAA;AAPN;AAYE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AAVJ;AAYI;EACE,yBAAA;EACA,qBAAA;AAVN;AAeE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AAbJ;AAiBE;EACE,yCAAA;EACA,oBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,yCAAA;AAfN;AAkBI;EACE,0CAAA;AAhBN;;AAqBA,6CAAA;AACA;EACE,gDAAA;AAlBF;;AAqBA;EACE,gDAAA;AAlBF;;AAqBA,8CAAA;AACA;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,uBAAA;AAlBF;;AAqBA,oCAAA;AAEE;EACE,uBAAA;EACA,iBAAA;EACA,YAAA;AAnBJ;AAqBI;EACE,0BAAA;EACA,gBAAA;AAnBN;AAsBI;EACE,yBAAA;EACA,qBAAA;AApBN;AAuBI;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AArBN;AAuBM;EACE,0BAAA;EACA,mBAAA;AArBR;AAyBI;EACE,yBAAA;EACA,cAAA;EACA,wBAAA;AAvBN;AA0BI;EACE,iBAAA;EACA,wBAAA;EACA,YAAA;AAxBN;AA0BM;EACE,yBAAA;AAxBR;AA8BI;EACE,0BAAA;AA5BN;AA+BI;EACE,uBAAA;AA7BN;;AAkCA,2BAAA;AACA;EACE;IACE,sBAAA;EA/BF;EAkCA;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EAhCF;EAkCE;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EAhCJ;EAoCA;IACE,iBAAA;EAlCF;AACF;AAqCA,sCAAA;AACA;EACE;IACE,UAAA;IACA,0BAAA;EAnCF;EAqCA;IACE,UAAA;IACA,wBAAA;EAnCF;AACF;AAsCA;EACE,kCAAA;AApCF;;AAuCA,yCAAA;AACA;EACE,gBAAA;AApCF;;AAuCA,4BAAA;AACA;EACE,YAAA;EACA,YAAA;AApCF;AAsCE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;EACA,oCAAA;EACA,gBAAA;AApCJ;;AAwCA;EACE;IACE,yBAAA;EArCF;AACF;AAwCA,oDAAA;AACA;EACE,2DAAA;EAMA,4CAAA;AA3CF;AAsCE;EACE,2CAAA;EACA,mBAAA;AApCJ;AAwCE;EACE,kBAAA;AAtCJ;AAwCI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,mBAAA;EACA,oBAAA;AAtCN","sourcesContent":["@import \"../../../theme/mixins\";\n\n/* Accessibility utilities */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Main container */\n.wrap {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n  \n  @include mobile {\n    flex-direction: column;\n    gap: 15px;\n  }\n}\n\n/* Section containers */\n.date-section, .time-section {\n  flex: 1;\n  min-width: 0; // Prevent flex item overflow\n}\n\n.section-heading {\n  color: #B0B0B0;\n  line-height: 17px;\n  margin: 5px 0 10px 0;\n  font-size: 14px;\n  font-family: OpenSans, sans-serif;\n  text-align: center;\n}\n\n/* Slot container */\n.slot-container {\n  width: 100%;\n}\n\n.slot-col {\n  min-height: 250px;\n  overflow-y: auto;\n  padding: 0;\n  \n  /* Improved scrollbar for accessibility */\n  scrollbar-width: thin;\n  scrollbar-color: var(--ion-color-primary) transparent;\n  \n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background-color: var(--ion-color-primary);\n    border-radius: 3px;\n  }\n  \n  /* Focus styles for listbox */\n  &:focus {\n    outline: 2px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n}\n\n/* Slot buttons */\n.slot-square {\n  background: white;\n  text-align: center;\n  padding: var(--ion-margin);\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n  cursor: pointer;\n  border-radius: 16px;\n  border: 1.5px solid var(--ion-color-primary);\n  color: var(--ion-color-secondary);\n  font-family: AppFontBold, sans-serif;\n  font-size: 14px;\n  width: 100%;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  /* Focus styles */\n  &:focus {\n    outline: 2px solid var(--ion-color-primary-shade);\n    outline-offset: 2px;\n    box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n  }\n  \n  /* Keyboard focus styles */\n  &:focus-visible {\n    outline: 2px solid var(--ion-color-primary-shade);\n    outline-offset: 2px;\n  }\n  \n  /* Hover state */\n  &:hover:not(:disabled) {\n    background-color: rgba(113, 167, 97, 0.1);\n    border-color: var(--ion-color-primary-shade);\n  }\n  \n  /* Active state */\n  &:active:not(:disabled) {\n    background-color: rgba(113, 167, 97, 0.2);\n    transform: translateY(1px);\n  }\n  \n  /* Selected state */\n  &.selected {\n    color: white;\n    background: var(--ion-color-primary);\n    font-weight: bold;\n    \n    &:hover {\n      background-color: var(--ion-color-primary-shade);\n    }\n    \n    &:focus {\n      outline-color: var(--ion-color-primary-tint);\n      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n    }\n  }\n  \n  /* Disabled state */\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background-color: #f5f5f5;\n    color: #999999;\n    border-color: #cccccc;\n    \n    &:hover {\n      background-color: #f5f5f5;\n      border-color: #cccccc;\n    }\n  }\n  \n  /* Smaller text variant */\n  &.smaller {\n    font-size: 11px;\n    padding: 16px 8px;\n    text-transform: lowercase;\n    min-height: 40px;\n  }\n  \n  /* More button styling */\n  &.more-button {\n    background-color: rgba(113, 167, 97, 0.1);\n    border-style: dashed;\n    font-weight: normal;\n    \n    &:hover {\n      background-color: rgba(113, 167, 97, 0.2);\n    }\n    \n    &:focus {\n      background-color: rgba(113, 167, 97, 0.15);\n    }\n  }\n}\n\n/* Specific styling for date and time slots */\n.date-slot {\n  /* Additional styling for date slots if needed */\n}\n\n.time-slot {\n  /* Additional styling for time slots if needed */\n}\n\n/* Legacy classes for backward compatibility */\n.header-color {\n  color: #B0B0B0;\n  line-height: 17px;\n  margin: 5px;\n  font-size: 14px;\n  font-family: OpenSans, sans-serif;\n  text-align: center;\n}\n\n.no-padding {\n  padding: 0px !important;\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  .slot-square {\n    border: 2px solid black;\n    background: white;\n    color: black;\n    \n    &:focus {\n      outline: 3px solid #0078d7;\n      box-shadow: none;\n    }\n    \n    &:hover:not(:disabled) {\n      background-color: #e6f3ff;\n      border-color: #0078d7;\n    }\n    \n    &.selected {\n      background: black;\n      color: white;\n      border: 2px solid white;\n      \n      &:focus {\n        outline: 3px solid #0078d7;\n        outline-offset: 2px;\n      }\n    }\n    \n    &:disabled {\n      background-color: #cccccc;\n      color: #666666;\n      border: 1px dashed black;\n    }\n    \n    &.more-button {\n      background: white;\n      border: 2px dashed black;\n      color: black;\n      \n      &:hover {\n        background-color: #e6f3ff;\n      }\n    }\n  }\n  \n  .slot-col {\n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    &::-webkit-scrollbar-thumb {\n      background-color: black;\n    }\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .wrap {\n    flex-direction: column;\n  }\n  \n  .slot-square {\n    font-size: 12px;\n    padding: 12px 8px;\n    min-height: 40px;\n    \n    &.smaller {\n      font-size: 10px;\n      padding: 12px 6px;\n      min-height: 36px;\n    }\n  }\n  \n  .slot-col {\n    max-height: 200px;\n  }\n}\n\n/* Animation for smooth interactions */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.slot-square {\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n/* Ensure proper spacing in grid layout */\n.slot-col > .slot-square:last-child {\n  margin-bottom: 0;\n}\n\n/* Loading state for slots */\n.slot-square.loading {\n  opacity: 0.6;\n  cursor: wait;\n  \n  &::after {\n    content: '';\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border: 2px solid currentColor;\n    border-radius: 50%;\n    border-top-color: transparent;\n    animation: spin 0.8s linear infinite;\n    margin-left: 8px;\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Focus management for better keyboard navigation */\n.slot-col[role=\"listbox\"] {\n  /* Allow listbox to receive focus for keyboard navigation */\n  &:focus {\n    outline: 2px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Highlight focused option within listbox */\n  .slot-square[aria-selected=\"true\"] {\n    position: relative;\n    \n    &::before {\n      content: '';\n      position: absolute;\n      top: -2px;\n      left: -2px;\n      right: -2px;\n      bottom: -2px;\n      border: 2px solid var(--ion-color-primary);\n      border-radius: 18px;\n      pointer-events: none;\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
